import { SettingsPlaceholder } from "@/pages/settings/settings-placeholder";

export function ActionsSettingsPage() {
  return (
    <SettingsPlaceholder
      title="Actions"
      description="Automation rules triggered on asset events. Deferred to Phase 2."
    />
  );
}
